// IE 2026 10 02 / ODOO-345042 (заказ Игоря: сообщения в консоли)
// Отладочные сообщения консоли — только по выключателю: localStorage 'webscm.debug' === '1' (DevTools: localStorage.setItem('webscm.debug', '1'),
// затем перезагрузка). По умолчанию тихо. Реальные сбои (console.warn / console.error) сюда НЕ идут.
export function debugLog_enabled() {
    try { return localStorage.getItem('webscm.debug') === '1' } catch (e) { return false }   // localStorage недоступен — тихо
}
export function debugLog(...args) {
    if (debugLog_enabled()) console.log(...args)
}
